export default __webpack_public_path__ + "media/images/work_with_us/work_hero_sm-8029161a46f714aa5c132063503f298f.png";